import * as paymentClaims from "../Actions/PaymentClaims";


export const paymentClaimsReducer = (state = {
  isLoading: false,
  data: [],
  isError: false
}, action) => {
  switch (action.type) {
    case paymentClaims.GET_PAYMENT_CLAIMS_DATA_REQUESTED:
      return { ...state, isLoading: true };
    case paymentClaims.GET_PAYMENT_CLAIMS_DATA_DONE:
      return { ...state, isLoading: false, data: action.data };
    case paymentClaims.GET_PAYMENT_CLAIMS_DATA_FAILED:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};
